import { z } from 'zod';
// Prompt BJ-10 — 'puesto' agregado: mismo patrón (lista plana, sin FK,
// gestionado con el mismo permiso canManageCatalogs que giro/origen_lead/
// plataforma/tier). 'area' NO vive aquí — tiene su propia tabla
// catalogo_areas por requerir un set de roles de gestión distinto.
export const TIPOS_CATALOGO = ['giro', 'origen_lead', 'plataforma', 'tier', 'puesto'];
// ── crearCatalogoItemSchema ───────────────────────────────────────────────────
export const crearCatalogoItemSchema = z.object({
    valor: z.string().min(1).max(200),
    orden: z.coerce.number().int().optional(),
});
// ── actualizarCatalogoItemSchema ──────────────────────────────────────────────
export const actualizarCatalogoItemSchema = z.object({
    valor: z.string().min(1).max(200).optional(),
    orden: z.coerce.number().int().nullable().optional(),
});
//# sourceMappingURL=catalogos.js.map